import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const BasicStandardTemplate = ({
  height = 80,
  width = 72,
  color = colors.white,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} {...props}>
    <rect width="71.1111" height="80" rx="4" fill={getColor(color, isColorInherited)} />
    <rect
      x="38.0833"
      y="22.0833"
      width="25.1667"
      height="17.1667"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <line
      x1="8.11108"
      y1="7.88892"
      x2="63"
      y2="7.88892"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="15"
      x2="63"
      y2="15"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="46.1111"
      x2="63"
      y2="46.1111"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="53.2222"
      x2="63"
      y2="53.2222"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="60.3333"
      x2="63"
      y2="60.3333"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="67.4443"
      x2="63"
      y2="67.4443"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="23"
      x2="30.1111"
      y2="23"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="31"
      x2="30.1111"
      y2="31"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="39"
      x2="30.1111"
      y2="39"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);
